import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "fees",
  initialState: {
    list: [],
    count: 0,

  },
  reducers: {
    setCommissions: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },
    countCommissions: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
  },
});
export const { setCommissions,countCommissions } = slice.actions;

export default slice.reducer;

export const getCommissionsSelector = (store) => store.fees.list;
export const getCommissionsCountSelector = (store) => store.fees.count;
